import "./Main.css"
import Image from "../Image/Image"
import Cards from "../cards/Cards"
import WidgetLeft from "../widgetLeft/WidgetLeft"
import WidgetRight from "../widgetRight/WidgetRight"

const Main = () => {
    return (
        <main>
            <Image />
            <div className="cont">
                <Cards />
                <div className="charts">
                    <WidgetLeft />
                    <WidgetRight />
                </div>
            </div>
        </main>
    )
}

export default Main;